import * as React from 'react';
import style from './admin-paper.scss';
import { Paper } from 'ui';
import { ScrollToTop } from 'ui/scroll-to-top/scroll-to-top';

const AdminPaperComponent: React.SFC<{}> = ({ children }) => {
  return (<Paper componentId="useradmin-paper" className={style.useradminPaper}>
    {children}
    <ScrollToTop/>
  </Paper>);
};

export const AdminPaper = AdminPaperComponent;
